import { CardHeader } from './components/card-header'

// notice: a status line under the header (what a header action is doing or
// last said), outside the scrolling body.
export const CardFullHeightScrollY = ({ children, title, subtitle, HeaderMenu, HeaderComponent, headerActions, notice }) => {
  return (
    <div className="card h-100">
      <div className="card-body d-flex flex-column pb-0 h-100">
        <CardHeader title={title} subtitle={subtitle} HeaderMenu={HeaderMenu} HeaderComponent={HeaderComponent} actions={headerActions} />
        {notice && <div className="card-notice" data-testid="card-notice">{notice}</div>}
        <div className="flex-fill" style={{ minHeight: 0 }}>
          <div className="overflow-y-scroll overflow-x-hidden h-100">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}
